export default {
  freightSourceShipownerTitle: 'Shipowner',
  freightSourcePeerTitle: 'Peer',
  freightSourceAgentPriceTitle: 'Agent Contract Rate',
  exportUserTitle: 'Exporter',
  exportStatusTitle: 'Export Status'
}
